import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Locale } from '@royalaholddelhaize/ah-locale';
import { ChevronLeft24Icon } from '@royalaholddelhaize/design-system-pantry-web/assets/icons/ah';
import {
    LinkButton,
    LinkText,
} from '@royalaholddelhaize/design-system-pantry-web/components/button/link-button/link-button';
import { LinkButtonProps } from '@royalaholddelhaize/design-system-pantry-web/components/button/link-button/link-button.interfaces';
import { createTestHook } from '../../utils/create-test-hook';
import { I18nProvider } from './i18n/i18n-provider';

type BackButtonProps = ComponentProps<'button'> & {
    locale?: Locale;
    label?: string;
};

const BackButtonComponent: React.FC<{ label?: string } & LinkButtonProps> = ({
    label,
    ...rest
}) => {
    const { t } = useTranslation('back-button');

    return (
        <LinkButton {...rest} {...createTestHook('back-button')}>
            <ChevronLeft24Icon size={15} />
            <LinkText
                level="secondary"
                size-="small"
                textDecoration="none"
                size="regular"
            >
                {label ?? t('label')}
            </LinkText>
        </LinkButton>
    );
};

export const BackButton: React.FC<BackButtonProps> = ({
    locale = Locale.nl_NL,
    ...rest
}) => (
    <I18nProvider locale={locale}>
        <BackButtonComponent {...rest} />
    </I18nProvider>
);
